import React from 'react';
import Button from '@atlaskit/button';
import '@atlaskit/css-reset';
import { capitalizeFirstLetter } from '../utils/utils';

export const PersonCasesResult = (props) => {
  const handleClick = (key) => {
    window.AP.navigator.go('issue', {
      issueKey: key,
    });
  };

  const openInNewTab = (element) => {
    const url = element.self;
    let domain = new URL(url);
    const host = domain.protocol + '//' + domain.hostname;

    const key = element.key;

    if (props.usersType === 'Licensed Users') {
      const newWindow = window.open(`${host}/browse/${key}`, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    } else {
      const newWindow = window.open(
        `${host}/servicedesk/customer/portal/1/${key}`,
        '_blank',
        'noopener,noreferrer'
      );
      if (newWindow) newWindow.opener = null;
    }
  };

  const openUrlNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  if (!props.data) return <div></div>;

  // if (props.data.length > 0) {
  //   let size = props.data.length * 50 + 200;
  //   if (size > 500) size = 500;

  //   window.AP.resize('100%', `${size}px`);
  //   window.AP.sizeToParent();
  // }

  // if (props.data.length > 0) {
  //   let size = props.data.length * 50 + 200;
  //   if (size > 500) size = 500;

  //   window.AP.resize('100%', `${size}px`);
  //   window.AP.sizeToParent();
  // } else {
  //   window.AP.resize('100%', `${props.defaultHeight ? props.defaultHeight : 100}px`);
  //   window.AP.sizeToParent();
  // }

  const transformAndCapitalize = (field, fieldArray) => {
    if (!fieldArray) return field;

    let fld = fieldArray.filter((n) => n.id === field)[0];
    let fldId = fld ? fld.name : field;

    return capitalizeFirstLetter(fldId);
  };

  const GetFieldValue = (element, field) => {
    if (element.fields) {
      const data = element.fields[field];
      if (!data) return '';

      if (field === 'status' || field === 'priority') return data?.name;

      if (
        field === 'description' ||
        (data.content && data.content[0] && data.content[0].type === 'paragraph')
      ) {
        let text = '';

        if (data && data.content && data.content.length > 0) {
          for (let i = 0; i < data.content.length; i++) {
            const content = data.content[i];
            if (content && content.content && content.content.length > 0) {
              let subContent = content.content[0];
              if (subContent.text) text = text + '; ' + subContent.text;
            }
          }
        }

        return text;
      }

      if (field === 'creator' || field === 'reporter' || data.displayName) return data?.displayName;

      if (typeof data === 'object' && !Array.isArray(data)) return data?.value;

      if (Array.isArray(data)) {
        const items = data.map((m) => {
          if (m['name']) return m['name'];
          if (m['displayName']) return m['displayName'];
          if (m['value']) return m['value'];

          if (typeof m === 'string') return m;

          return '';
        });

        return items.join();
      }

      return element.fields[field];
    } else if (element.requestFieldValues) {
      const data = element.requestFieldValues.filter(
        (d) => d.fieldId === field || d.label === field
      )[0];
      return data ? data.value : '';
    }

    return '';
  };

  return (
    <div>
      <div style={{ marginTop: '10px' }}>
        <span style={{ color: '#6b778c', fontSize: 12, fontWeight: 600 }}>Issue Info Sheet</span>
      </div>
      <div style={{ maxHeight: '300px', overflowX: 'auto', marginTop: '5px' }}>
        <table className='aui' style={{ fontSize: '12px' }}>
          <thead style={{ fontSize: '12px', color: '#5e6c84' }}>
            <tr>
              <th>Key</th>
              {props.fields.map((field) => {
                return (
                  <th style={{ width: '30%' }}>
                    {transformAndCapitalize(field, props.issueFieldsArray)}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {props.data.map((element, index) => {
              return (
                <tr>
                  <td>
                    <Button
                      appearance='link'
                      id='btnCaseInfo'
                      onClick={() => openInNewTab(element)}
                    >
                      {element.key ? element.key : element.issueKey ? element.issueKey : 'N/A'}
                    </Button>
                  </td>
                  {props.fields.map((field, index) => {
                    return <td>{GetFieldValue(element, field)}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
